var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogs = function SvgLogs(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 492.308 492.308",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.373 349.298v143.01h487.563v-143.01H2.373zm467.87 123.317H22.065V368.99h448.178v103.625z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.171 397.375v28.375H192.132v-28.375H172.44v48.067h147.423v-48.067zM2.373 174.644v143.01h487.563v-143.01H2.373zm467.87 123.318H22.065V194.337h448.178v103.625z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.171 222.731v28.375H192.132v-28.375H172.44v48.067h147.423v-48.067zM2.373 0v143h487.563V0H2.373zm467.87 123.308H22.065V19.692h448.178v103.616z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.171 48.077v28.375H192.132V48.077H172.44v48.067h147.423V48.077z"
  })));
};
export default SvgLogs;